export const captchaConfig = {
  type: 1,
  length: 6,
  cssClass: "custom",
  back: {
    stroke: "#2F9688",
    solid: "#f2efd2",
  },
  font: {
    color: "#000000",
    size: "35px",
  },
};

export const SHOW_CAPTCHA_ON_FAILED_ATTEMPTS = 3;
export const isOfflineCaptcha = import.meta.env
  .VITE_ON_PREM_RESTRICTION_CAPTCHA; // Set this based on your environment configuration
export const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITEKEY;
